import { createFileRoute } from "@tanstack/react-router";
import { DelawareWorkMap } from "#/components/pages/work/DelawareWorkMap";
import { RecentWorkGrid } from "#/components/pages/work/RecentWorkGrid";
import { FinalCTA } from "#/components/pages/home";
import { PageHeader } from "#/components/shared/PageHeader";
import { HEADER } from "#/lib/images";

const TITLE = "Our Work Across Delaware | Blue Rock Concrete";
const DESCRIPTION =
  "Explore real Blue Rock Concrete projects on an interactive Delaware map: driveways, stamped patios, walkways, and slabs in Hockessin, Newark, Greenville, New Castle, and Middletown.";

export const Route = createFileRoute("/our-work")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:url", content: "https://bluerockconcreteco.com/our-work" },
    ],
    links: [{ rel: "canonical", href: "https://bluerockconcreteco.com/our-work" }],
  }),
  component: OurWorkPage,
});

function OurWorkPage() {
  return (
    <main>
      <PageHeader
        eyebrow="Our Work"
        title="Poured, finished, and standing all over Delaware"
        intro="Driveways, patios, walkways, and slabs across New Castle County. Every project below was poured, finished, and sealed by our own crew."
        image={HEADER.work.src}
        imageMobile={HEADER.work.mobile}
        imageAlt={HEADER.work.alt}
      />

      <RecentWorkGrid />
      <DelawareWorkMap />
      <FinalCTA />
    </main>
  );
}
